// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 956) return "themes/sweetco/assets/js/956.js";
	if (chunkId === 380) return "themes/sweetco/assets/js/380.js";
	// return url for filenames based on template
	return undefined;
};